export function arrayEquals(a, b) {
    // console.log("arrayEquals::arrayEquals()");
    return a && b && a.length === b.length &&
        a.every((v, i) => {
            // console.log("v = '" + JSON.stringify(v) + "'");
            // console.log("b[i] = '" + JSON.stringify(b[i]) + "'");
            return JSON.stringify(v) === JSON.stringify(b[i])
        });
}

/** busca en el array aquel elemento prop === value
 *
 * @param array {object[]}
 * @param prop {string}
 * @param value {string}
 * @returns {object} array[{}].prop === value
 */

export function findByProp(array=[], prop, value) {
    const obj = array?.find(r => r[prop] === value)
    if (obj) return obj
    return undefined
}


export function getItemLocalStorage(key) {
    let dataStrLS;
    // console.log("utils::getFromLocalStorage(key = '" + key + "')")
    try {
        dataStrLS = localStorage?.getItem(key)
    } catch (e) {
        console.error("LocalStorage is not accesible");
    }
    if (!dataStrLS) return undefined

    const data = JSON.parse(dataStrLS)

    if (data?.expiry && data.value){
        const now = new Date().getTime()
        // console.log("now = " + new Date(now).toISOString())
        // console.log("expiry = " + new Date(data?.expiry).toISOString())
        // console.log("time ti expiry = " + (data?.expiry - now)+"ms")
        if (now > data?.expiry){
            localStorage?.removeItem(key)
            return undefined
        }
        return data.value;
    }
    return data;
}
